/**
 * "Opened from the Marketing Morning Digest" context for a deep link.
 *
 * Digest buttons (backend/digest_links.py) append `src=digest`,
 * `digest=YYYY-MM-DD` (the digest's day) and, where the email showed a
 * count, `snap=N`. The screen shows that as context — "the email said
 * 91" — beside its LIVE count. It never filters by these keys and never
 * makes the screen show the old number.
 */

export const ORIGIN_KEYS = ["src", "digest", "snap"];

/** URL query -> {day, snapshot} for a digest visit, or null. */
export function digestOriginFromSearch(search) {
  const p = new URLSearchParams(search || "");
  if (p.get("src") !== "digest") return null;
  const day = /^\d{4}-\d{2}-\d{2}$/.test(p.get("digest") || "") ? p.get("digest") : null;
  const snapRaw = p.get("snap");
  const snap = snapRaw !== null && /^\d+$/.test(snapRaw) ? Number(snapRaw) : null;
  return { day, snapshot: snap };
}

/** Append the origin keys to a URLSearchParams (to keep them on rewrite). */
export function appendOrigin(params, origin) {
  if (!origin) return params;
  params.set("src", "digest");
  if (origin.day) params.set("digest", origin.day);
  if (origin.snapshot !== null && origin.snapshot !== undefined) params.set("snap", String(origin.snapshot));
  return params;
}

/** "Fri 30 Oct 2026" from "2026-10-30", without a timezone shift. */
export function formatDigestDay(day) {
  if (!day) return "";
  const [y, m, d] = day.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  return dt.toLocaleDateString("en-GB", {
    weekday: "short", day: "numeric", month: "short", year: "numeric", timeZone: "UTC",
  });
}

/**
 * The sentence the screen shows. `current` is the live record count, or
 * null while it loads.
 */
export function digestOriginText(origin, current) {
  if (!origin) return "";
  const when = origin.day ? ` — ${formatDigestDay(origin.day)}` : "";
  const parts = [`Opened from the Marketing Morning Digest${when}.`];
  if (origin.snapshot !== null && origin.snapshot !== undefined) {
    parts.push(`The email counted ${origin.snapshot.toLocaleString()}.`);
    if (current !== null && current !== undefined) {
      parts.push(current === origin.snapshot
        ? `${current.toLocaleString()} now.`
        : `${current.toLocaleString()} now — this screen shows the current records, which change as they are handled.`);
    }
  }
  return parts.join(" ");
}
